import React from "react";
import styled from "styled-components";

function Footer() {
  return (
    <Container>
      <LogoSection>
        <img src="./logo (1).png" alt="" />
        <p>
          Fast delivery, which is active all over the world, serves with many
          transportation vehicles.
        </p>
      </LogoSection>
      <Navs>
        <NavColumns>
          <h4>Company</h4>
          <p>About Us</p>
          <p>Blogs</p>
          <p>All Products</p>
          <p>Locations Map</p>
        </NavColumns>
        <NavColumns>
          <h4>Service</h4>
          <p>Order Tracking</p>
          <p>Wish List</p>
          <p>My account</p>
          <p>Terms & Conditions</p>
        </NavColumns>
      </Navs>
      <RightContainer>
        <h4>Get In Touch</h4>
        <p>Subscribe to our weekly Newsletter and receive updates via email.</p>
      </RightContainer>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  margin: auto;

  padding: 60px 0;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  @media only screen and (max-width: 767px) {
    /* Styles */
    flex-direction: column;
  }
`;
const LogoSection = styled.div`
  width: 200px;

  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin-top: 20px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    text-align: center;
    /* or 16px */

    /* TEXT CLR */

    color: #5e6282;
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      /* Styles */

      font-size: 11px;
    }
  }
`;

const Navs = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 400px;
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* Styles */

    width: 250px;
  }
  @media only screen and (max-width: 767px) {
    /* Styles */
    flex-direction: column;
  }
`;

const NavColumns = styled.div`
  margin-top: 40px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  h4 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    /* identical to box height, or 111% */

    letter-spacing: -0.01em;
    margin-bottom: 15px;

    color: #2e2e2e;
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      /* Styles */

      font-size: 13px;
      line-height: 16px;
    }
  }

  p {
    font-family: "Poppins";
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 35px;
    /* or 250% */

    color: #676767;
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      /* Styles */

      font-size: 11px;
    }
  }
`;

const RightContainer = styled.div`
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (max-width: 767px) {
    /* Styles */
    margin-top: 60px;
  }
  h4 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 15px;
    /* identical to box height, or 111% */

    letter-spacing: -0.01em;

    color: #2e2e2e;
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      /* Styles */

      font-size: 13px;
    }
  }

  p {
    font-family: "Poppins";
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 20px;
    text-align: center;
    /* or 162% */

    color: #888888;
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      /* Styles */
      font-size: 11px;
    }
  }
`;

export default Footer;
